
import FloatingCardComponent from "@/components/Shared/RegisterTest/FloatingCard/FloatingCardComponent";
export default FloatingCardComponent;
